import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { getProjects, deleteProject, updateProject } from './api';
import ConfirmModal from './ConfirmModal'; // ConfirmModalをインポート

function ProjectList({ onProjectSelect, onProjectDelete, currentProjectId }) {
    const [projects, setProjects] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [projectToDelete, setProjectToDelete] = useState(null);
    const [editingProjectId, setEditingProjectId] = useState(null);
    const [newProjectName, setNewProjectName] = useState('');

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await getProjects();
                setProjects(response.data);
            } catch (error) {
                console.error('Error fetching projects', error);
            }
        };

        fetchProjects();
    }, []);

    const handleDeleteClick = (projectId) => {
        ReactGA.event('click_delete_project', {
            event_category: 'Button',
            event_label: 'Delete_Project',
        });

        setProjectToDelete(projectId);
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        if (projectToDelete) {
            try {
                await deleteProject(projectToDelete);
                const updatedProjects = projects.filter(project => project.id !== projectToDelete);
                setProjects(updatedProjects);
                setShowModal(false);
                setProjectToDelete(null);

                if (projectToDelete === currentProjectId) {
                    onProjectDelete();
                }
            } catch (error) {
                console.error('Error deleting project', error);
            }
        }
    };

    const handleCancelDelete = () => {
        setShowModal(false);
        setProjectToDelete(null);
    };

    const handleEditClick = (projectId, projectName) => {
        ReactGA.event('click_edit_project', {
            event_category: 'Button',
            event_label: 'Edit_Project',
        });

        setEditingProjectId(projectId);
        setNewProjectName(projectName);
    };

    const handleSaveClick = async (projectId) => {
        try {
            const projectToUpdate = projects.find(project => project.id === projectId);
            const updatedProjectData = {
                ...projectToUpdate,
                name: newProjectName,
                audio_data: projectToUpdate.audio_data,
                position_ref: projectToUpdate.position_ref,
                index_ref: projectToUpdate.index_ref
            };
            await updateProject(projectId, updatedProjectData);
            const updatedProjects = projects.map(project =>
                project.id === projectId ? { ...project, name: newProjectName } : project
            );
            setProjects(updatedProjects);
            setEditingProjectId(null);
            setNewProjectName('');
        } catch (error) {
            console.error('Error updating project name', error);
        }
    };

    const handleCancelEdit = () => {
        setEditingProjectId(null);
        setNewProjectName('');
    };

    return (
        <div>
            <h2>音声データ一覧</h2>
            <ul className="project-list">
                {projects.map((project) => (
                    <li
                        key={project.id}
                        className="project-item"
                        onClick={editingProjectId === project.id ? null : () => onProjectSelect(project.id)}
                    >
                        {editingProjectId === project.id ? (
                            <div className="project-edit">
                                <input
                                    type="text"
                                    value={newProjectName}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => setNewProjectName(e.target.value)}
                                    className="project-input"
                                />
                                <button onClick={(e) => { e.stopPropagation(); handleSaveClick(project.id); }} className="project-button save-button">保存</button>
                                <button onClick={(e) => { e.stopPropagation(); handleCancelEdit(); }} className="project-button cancel-button">キャンセル</button>
                            </div>
                        ) : (
                            <div className="project-view">
                                <i className="fas fa-music project-icon"></i>
                                <div className="project-name">{project.name}</div>
                                <div className="action-icons">
                                    <button onClick={(e) => { e.stopPropagation(); handleEditClick(project.id, project.name); }} className="edit-icon-btn">
                                        <i className="fas fa-pencil-alt"></i>
                                    </button>
                                    <button onClick={(e) => { e.stopPropagation(); handleDeleteClick(project.id); }} className="delete-icon-btn">
                                        <i className="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
            {showModal && (
                <ConfirmModal
                    message="プロジェクトを削除します。本当によろしいですか？"
                    onConfirm={handleConfirmDelete}
                    onCancel={handleCancelDelete}
                />
            )}
        </div>
    );
}

export default ProjectList;
